module.exports = __webpack_public_path__ + "static/media/_apostrophe.02783329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_apostrophe.jpg
// module id = 7
// module chunks = 0